import { AuthorizePolicies } from '@platform/platform.state';
import { RouteData } from '@platform/routing/route.model';

export interface AuthorizeRouteData {
  policies: AuthorizePolicies[];
}

export interface AuthorizeOptions {
  values: { [index: string]: string };
}

export function createAuthorizeRouteData(policies: AuthorizePolicies[]): RouteData {
  return { authorize: { policies } };
}
